module.exports = new __parcel__URL__("floor-lg.a55d3056.jpg").toString();